<template>
  <div style="display: flex; flex-direction: row; gap: 4px">
    <AwIcon v-if="copied" name="i-ph-check-circle" />
    <AwIcon v-else name="i-ph-copy" class="cursor-pointer" @click.stop="copyToClipboard" />
  </div>
</template>

<script setup lang="ts">
import { useToast } from "~/composables/useToast";
import { ref } from "vue";

const { addToastSuccess, addToastError } = useToast();

const props = defineProps<{
  text: string;
}>();

const icon = ref("i-ph-copy");
const { copy, copied } = useClipboard();
const showCopiedText = ref(false);

const copyToClipboard = async () => {
  try {
    await copy(props.text);
    showCopiedText.value = true;
    icon.value = "i-ph-check-circle";
    addToastSuccess({
      title: "Copié !",
      description: "Le texte a été copié dans le presse-papier.",
    });
  } catch {
    addToastError({
      title: "Impossible de copier le texte",
      description: "Vous devez probablement autoriser l'accès à votre presse-papier.",
    });
  }
};
</script>

<style scoped lang="scss">
.copied-text {
  color: var(--gray-2);
  font-size: 10px;
}
</style>
